import { render, staticRenderFns } from "./TrendyolKategori.vue?vue&type=template&id=502c6727&scoped=true"
import script from "./TrendyolKategori.vue?vue&type=script&lang=js"
export * from "./TrendyolKategori.vue?vue&type=script&lang=js"
import style0 from "./TrendyolKategori.vue?vue&type=style&index=0&id=502c6727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502c6727",
  null
  
)

export default component.exports